<template>
  <teleport to="body">
    <div v-if="isVisible" class="modal-overlay-vue" :class="[modalWrapClass, { 'visible': animateIn }]" @click.self="closeModal">
      <div class="modal-content" :class="[modalClass, { 'in': animateIn }]" ref="modalContent">
        <div v-if="!isNowrap">
          <div class="modal-header">
            <slot name="header">
              <h4 class="modal-title">{{ modalTitle }}</h4>
            </slot>
            <button class="button modal-button modal-button--close" type="button" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
        <slot v-else></slot>
      </div>
    </div>
  </teleport>
  
</template>
  <script>
  import scrollLock from 'scroll-lock';
  
  export default {
    name: 'Modal',
    props: {
      show: {
        type: Boolean,
        required: true
      },
      inHeader: {
        type: Boolean,
        required: false
      },
      doubleModal: {
        type: Boolean,
        default: false
      },
      modalTitle: {
        type: String,
        required: false
      },
      modalClass: {
        type: String,
        default: ''
      },
      modalWrapClass: {
        type: String,
        default: ''
      },
      isNowrap: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        scrollY: 0,
        animate: false,
        animateIn: false,
        isVisible: false,
        _closeTimer: null,
        _closeModalTimer: null
      };
    },
    emits: ['close'],
    watch: {
        show(newVal) {
          const pageWrap = document.querySelector('.page-wrap');
          const header = document.querySelector('.header-inner');
          // const modalContent = this.$refs.modalContent;

          if (newVal) {
            clearTimeout(this._closeTimer);
            clearTimeout(this._closeModalTimer);

            this.isVisible = true;

            if (!this.doubleModal) {
              this.scrollY = window.scrollY;

              document.body.style.top = `-${this.scrollY}px`;
              document.body.classList.add('modal-open-vue');
            }
            if (!this.inHeader) {
              pageWrap.classList.add('modal-open-vue');
              header.classList.add('modal-open-vue');
            }

            setTimeout(() => {
              this.animate = true;
              this.animateIn = true;
            }, 5);
          } else {
            this.animateIn = false;
            // scrollLock.clearQueueScrollLocks();
            // scrollLock.enablePageScroll(document.body);
            
            //this.closeModal();
            this._closeTimer = setTimeout(() => {
              this.$nextTick(() => {
                const openedModals = document.querySelectorAll('.modal-overlay-vue.visible');

                if (openedModals.length === 0 && !this.doubleModal) {
                  document.body.classList.remove('modal-open-vue');
                  document.body.style.top = '';
                  window.scrollTo(0, this.scrollY);
                }

                if (!this.inHeader && openedModals.length === 0) {
                  pageWrap.classList.remove('modal-open-vue');
                  header.classList.remove('modal-open-vue');
                }

                this.isVisible = false;
              });
            }, 500);
          }
        }
    },
    methods: {
        closeModal() {
          this.animateIn = false;

          this._closeModalTimer = setTimeout(()=>{
            this.$emit('close');
          },500)
        }
    },
    beforeUnmount() {
      this.animateIn = false
      this.animate = false
      document.body.classList.remove('modal-open-vue');
      const pageWrap = document.querySelector('.page-wrap');
      if (pageWrap) {
        // pageWrap.classList.remove('modal-open-vue');
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .modal-overlay-vue {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(17, 21, 26, 0.8);
    backdrop-filter: blur(5px);
    transition: opacity 0.6s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999999;
    opacity: 0;
    visibility: visible;
    @media (max-width: 767px) {
      top: 43px;
      height: calc(100dvh - 43px);
      justify-content: flex-start;
      align-items: flex-end;
    }
    &.modal-bottom{
      @media (max-width: 767px) {
        align-items: flex-end;
        bottom: 0;
      }
    }
    &.visible {
      opacity: 1;
      visibility: visible;
    }
    &.fade-disable {
      background: transparent;
      backdrop-filter: blur(0);
    }
  }
  
  .modal-content {
    background: #F5F5F5;
    border-radius: 10px;
    transform: translateY(15%) scale(0.2);
    transition: transform 0.7s cubic-bezier(0.34, 1.2, 0.64, 1), opacity 0.5s ease !important;
    width: 90%;
    max-width: 500px;
    position: relative;
    max-height: 90%;
    overflow-y: auto;
    opacity: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    transform-origin: center 60%;
    @media (max-width: 767px) {
      transform: translateY(100%) scale(1);
      transform-origin: center bottom;
      width: 100%;
      opacity: 1;
      border-radius: 0;
      height: 100%;
      max-width: 100%;
      max-height: fit-content;
      transition: transform 0.5s ease !important;
    }
    &.in{
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    .modal-header{
      display: flex;
      justify-content: space-between;
      padding: 30px;
      position: relative;
      &::before,
      &::after{
        content: none;
      }
    }
    .modal-body{

    }
    
    .modal-button {
      background: transparent;
      border: none;
      box-shadow: none;
      margin: 0;
      outline: none;
      padding: 0;
  
      &:hover {
        background: transparent;
      }
  
      &--close {
        display: inline-block;
        position: relative;
        width: 24px;
        height: 24px;
        opacity: 0.5;
        position: absolute;
        right: 30px;
        top: 30px;
        opacity: 0.5;
        transition: 0.3s all;
        z-index: 1;
        &:hover{
          opacity: 1;
        }
  
        &:before,
        &:after {
          content: '';
          background: #9BA1AB;
          display: block;
          position: absolute;
          width: 100%;
          height: 2.3px;
          border-radius: 5px;
          left: 0;
          top: 50%;
          transform-origin: center center;
        }
  
        &:before {
          transform: rotate(45deg);
        }
  
        &:after {
          transform: rotate(-45deg);
        }
      }
    }
  }
  
  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  </style>